import { Handle, Position } from 'reactflow'
import { useCurrentActivity } from '../store'

const EndRejectedActivity = ({ data }) => {
  const setCurrentActivity = useCurrentActivity((state) => state.setCurrentActivity)

  const handleClick = () => {
    setCurrentActivity(data?.activity)
  }

  const isCurrentEndState =
    data?.isCurrentPosition ||
    data?.isActive ||
    data?.isCompleted ||
    data?.isCurrent ||
    data?.isHighlighted ||
    data?.taskProcessData?.status === 'completed' ||
    data?.taskProcessData?.status === 'closed'

  const getNodeStyle = () => {
    const baseStyle = {
      padding: 20,
      backgroundColor: '#cb4c4a',
      color: 'white',
      borderRadius: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 120,
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    }

    if (isCurrentEndState) {
      return {
        ...baseStyle,
        border: '4px solid #FFD700',
        boxShadow: '0 0 20px rgba(255, 215, 0, 0.8)',
      }
    }

    return {
      ...baseStyle,
      border: '2px solid #d32f2f',
      boxShadow: '2px 2px 6px gray',
    }
  }

  return (
    <>
      <Handle type="target" position={Position.Left} />
      <div
        onClick={handleClick}
        style={getNodeStyle()}
        className="activity-node end-rejected"
        onMouseEnter={(e) => {
          if (isCurrentEndState) {
            e.target.style.boxShadow = '0 0 30px rgba(255, 215, 0, 1)'
            e.target.style.transform = 'scale(1.05)'
          }
        }}
        onMouseLeave={(e) => {
          if (isCurrentEndState) {
            e.target.style.boxShadow = '0 0 20px rgba(255, 215, 0, 0.8)'
            e.target.style.transform = 'scale(1)'
          }
        }}
      >
        <p style={{ margin: 0, fontSize: '14px' }}>
          {data?.activity?.activity_template_name || 'End Rejected'}
        </p>
      </div>
    </>
  )
}

export default EndRejectedActivity
